import { render } from "./BasicSearch.vue?vue&type=template&id=0872b22d&scoped=true"
import script from "./BasicSearch.vue?vue&type=script&lang=js"
export * from "./BasicSearch.vue?vue&type=script&lang=js"

import "./BasicSearch.vue?vue&type=style&index=0&id=0872b22d&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0872b22d"]])

export default __exports__